import React from 'react';
import Select from 'react-select';
import './react-select.css';

export default class ReactSelectAsync extends React.Component{    
    
    render(){
        const height = this.props.height? `${this.props.height.toString()}px` : '25px'
        return(
            < Select.Async style={{height:height}} value={this.props.value} placeholder='Seleccione...' noResultsText='No existen resultados' searchPromptText='Escriba para buscar' loadingPlaceholder='Buscar...'
            onChange={this.props.func_onChange} onBlur={this.props.func_onBlur} loadOptions={this.props.func_loadOptions} cache={false} disabled={this.props.disabled}
            onFocus={this.props.func_OnFocus} ref={this.props.func_ref}
            />
        )
    }
}    